import React from "react";
import { COMPONENT_TYPE } from "../constants/common";
import CustomInput from "./CustomInput";
import OutputWindow from "./OutputWindow";

const DetailsWindow = ({
  outputs,
  type,
  testCaseInput,
  setTestCaseInput
}) => {
  
  const isInputComponent = type === COMPONENT_TYPE.INPUT;

  return (
    <>
      {
        isInputComponent ?
        (
          <CustomInput
            testCaseInput={testCaseInput}
            setTestCaseInput={setTestCaseInput}
          />
        ) : (
          <OutputWindow 
            outputs={outputs}
          />
        )
      }
    </>
  );
};

export default DetailsWindow;